<template>
  <v-card outlined>
        <v-toolbar flat>
            <v-toolbar-title class="text-uppercase body-1 font-weight-medium">Interval Data</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>

            <div class="flex-grow-1"></div>

            <!-- search ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <v-col cols="3" sm="3" md="3">
              <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
              ></v-text-field>
            </v-col>
        </v-toolbar>

        <v-data-table
            :headers="headers"
            :items="intervals"
            :single-expand="false"
            :expanded.sync="expanded"
            :search="search"
            :sort-by="['ending']"
            :sort-desc="[false]"
            :items-per-page="15"
            item-key="ending"
            show-expand
            multi-sort
            dense
            >
            <!-- header ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <template v-slot:top>
              <p>&nbsp;</p>
            </template>

            <!-- no-data ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <template slot="no-data" class="text-left">
                <span class="subheading text-left">
                    <v-icon color="orange">warning</v-icon>
                    No interval data found.
                </span>
            </template>

            <!-- expansion button ~*~*~*~*~*~*~*~* -->
            <!-- display/not display expansion icon & panel -->
            <template v-slot:item.data-table-expand="{ item, isExpanded, expand }" width="10">
                <v-btn @click="expand(true)" v-if="item.programs != null && !isExpanded" text icon color="orange">
                    <v-icon large>arrow_drop_down</v-icon>
                </v-btn>
                <v-btn @click="expand(false)" v-if="item.programs != null && isExpanded" text icon color="green">
                    <v-icon large>arrow_drop_up</v-icon>
                </v-btn>
            </template>
            <!-- content  ~*~*~*~*~*~*~*~* -->
            <!-- could format in create then not have this section ... ? -->
            <template v-slot:item.ending="{ item }">
                {{ item.ending | $_datetimeFilter_timestamp_no_seconds }}
            </template>
            <template v-slot:item.guidance="{ item }">
                {{ item.guidance | $_dataFilter_guidance }}
            </template>
            <template v-slot:item.loadForecastKw="{ item }">
                {{ item.loadForecastKw | $_powerFilter_kw }}
            </template>
            <template v-slot:item.targetOutputKw="{ item }">
                {{ item.targetOutputKw | $_powerFilter_kw }}
            </template>
            <template v-slot:item.totalValueAtStake="{ item }">
                {{ item.totalValueAtStake | $_currencyFilter_usd }}
            </template>
            
            <!-- expansion panel data  ~*~*~*~*~*~*~*~* -->
            <template v-slot:expanded-item="{ item }">
                <td><!-- placeholder for expansion icon column, better presentation --></td>
                <td :colspan="headers.length">
                    <!-- <pre>{{ item.programs }}</pre> -->
                    <v-simple-table class="sustaine-expanded-table" elevation-0>
                        <template v-slot:default>
                            <tbody>
                                <template v-for="(program, p) in item.programs">
                                    <tr v-bind:key="'p' + p + program.programId">
                                        <th class="text-center">Program</th>
                                        <th class="text-center">Value Stream</th>
                                        <th class="text-right">Amount</th>
                                        <th class="text-right">Price</th>
                                        <th class="text-right">Value</th>
                                    </tr>
                                    <template v-for="(charge,c) in program.demandCharges">
                                        <tr v-bind:key="'p' + p + program.programId + 'c' + charge.demandChargeId">
                                            <td>{{ program.description }}</td>
                                            <td>{{ charge.description }}</td>
                                            <td class="text-right">{{ charge.demandChargeKw | $_powerFilter_kw }}</td>
                                            <td class="text-right">{{ charge.demandChargePriceMw | $_currencyFilter_usd }}</td>
                                            <td class="text-right">{{ charge.valueAtStake | $_currencyFilter_usd }}</td>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                        </template>
                    </v-simple-table>
                </td>
            </template>
        </v-data-table>
    </v-card>
</template>
<script>
  export default {
  props: {
      intervals: {
        type: Array,
        required: true
      }
    },
    data () {
      return {
        search: '',
        expanded: [],
        singleExpand: false,
        headers: [
          {
            text: 'ENDING',
            align: 'right',
            sortable: true,
            value: 'ending'
          },
          {
            text: 'GUIDANCE',
            align: 'right',
            sortable: true,
            value: 'guidance'
          },
          {
            text: 'FORECAST LOAD',
            align: 'right',
            sortable: true,
            value: 'loadForecastKw'
          },
          {
            text: 'TARGET OUTPUT',
            align: 'right',
            sortable: true,
            value: 'targetOutputKw'
          },
          {
            text: 'VALUE',
            align: 'right',
            sortable: true,
            value: 'totalValueAtStake'
          }
        ],
        subheaders: [
          {
            text: 'PROGRAM',
            align: 'right',
            sortable: true,
            value: 'description'
          },
          {
            text: 'GUIDANCE',
            align: 'right',
            sortable: true,
            value: 'guidance'
          },
          {
            text: 'PROGRAM (KW)',
            align: 'right',
            sortable: true,
            value: 'programKw'
          },
          {
            text: 'PROGRAM PRICE ($/kW)',
            align: 'right',
            sortable: true,
            value: 'programPriceMw'
          },
          {
            text: 'VALUE',
            align: 'right',
            sortable: true,
            value: 'valueAtStake'
          }
        ],

      }
    }
  }
</script>
<style lang="scss"scoped>.sustaine-expanded-table {
    background-color: rgba(0, 0, 0, 0) !important;

    /* transparent */
    th {
        color: #335b98 !important;
        font-weight: 600 !important;
        font-size: 11px !important;
        text-transform: uppercase !important;
        height: 28px !important;
        padding-top: 2px;
    }

    td {
        height: 32px !important;
    }
}

</style>